import { Fragment } from 'react';

import { useRouteInfo } from '../../../../contexts/route_info_context';
import { noop } from '../../../tailwind-ui';
import type { NavbarItems } from '../types';

interface MobileNavItemsProps {
  items: NavbarItems;
}

export function MobileNavItems(props: MobileNavItemsProps) {
  const { items } = props;
  const { isNmrium } = useRouteInfo();
  const filteredItems = items.filter(
    (item) => !item.hideOnMobile && !(item.hideOnNmriumPage && isNmrium),
  );
  const buttons = filteredItems.filter((item) => item.type === 'button');

  return (
    <>
      {buttons.map(
        (item) =>
          'smallAction' in item && (
            <Fragment key={item.name}>
              {item.smallAction(item.name, noop)}
            </Fragment>
          ),
      )}
    </>
  );
}
